import { CommonModule } from '@angular/common';
import { Component, ComponentFactoryResolver, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CommondataService } from '../../source/services/games/commondata.service';
import { Router, RouterModule } from '@angular/router';
import { SlotsService } from '../../source/services/slotsservice/slots.service';
import { QuickloginComponent } from '../quicklogin/quicklogin.component';
import { LoginState } from '../../source/appstates/loginstates/loginState';
import * as loginActions from '../../source/appstates/loginstates/loginActions'
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions'
import * as appState from '../../source/appstates/appState'
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { style } from '@angular/animations';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  @ViewChild('alertHost', { read: ViewContainerRef }) alertHost!: ViewContainerRef;
  showApkButton = false;
  currentYear: any;
  ETH_to_USD: any;
  closeSub: any;
  private loginSub: Subscription;
  private storeSub: Subscription | null = null;
  playerLoggedIn: boolean = false;
  selectedLang: any = localStorage.getItem('lang')
  openClose: boolean = false
    ; languages = [
      { code: 'EN', label: 'English' },
      { code: 'BN', label: 'Bangladesh' }
    ];
  constructor(private store: Store<appState.AppState>, private translate: TranslateService, private router: Router, private slotsservice: SlotsService, private componentFactoryResolver: ComponentFactoryResolver) {
    this.loginSub = this.store.select("loginState")
      .subscribe((loginState: LoginState) => {
        this.playerLoggedIn = loginState.playerLoggedIn?.loggedIn || false;
        if (!this.playerLoggedIn) {
          // this.router.navigate(["/home"]);
        }
      });
  }
  ngOnInit() {
    this.currentYear = new Date().getFullYear()
    const isAndroid =
      /Android/i.test(navigator.userAgent);
    const isCordova =
      typeof (window as any).cordova !== 'undefined';
    this.showApkButton = isAndroid && !isCordova;
    
  }

  ngOnDestroy() {
    this.loginSub.unsubscribe();
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  scrollToSection(sectionId: string) {
    this.router.navigate(['/policies'], { fragment: sectionId });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }





  openLiveSupport() {
    if (window && (window as any).Tawk_API) {
      (window as any).Tawk_API.maximize();
    } else {
      console.warn('Tawk_API is not available yet.');
    }
  }

  showPopUp(value: string) {
    this.store.dispatch(new loginActions.ResetState());
    const alertCmpFactory = this.componentFactoryResolver.resolveComponentFactory(
      QuickloginComponent
    );
    const hostViewContainerRef = this.alertHost;
    hostViewContainerRef.clear();
    const componentRef = hostViewContainerRef.createComponent(alertCmpFactory);
    componentRef.instance.formState = value;
    this.closeSub = componentRef.instance.close.subscribe(() => {
      this.closeSub.unsubscribe();
      hostViewContainerRef.clear();
    });
  }

}
